import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

import type { PopupKey } from "@performyard/service-contracts";

import { dismissPopup, getPopupDismissed } from "../../services/defs/internal-api";

const popupQueryKey = (popupKey: PopupKey) => ["popup-dismissal", popupKey];

/** Whether the current user has permanently dismissed the given popup. */
export const usePopupDismissed = (popupKey: PopupKey, enabled = true) =>
	useQuery({
		queryKey: popupQueryKey(popupKey),
		queryFn: () => getPopupDismissed(popupKey),
		enabled,
		// Dismissal is permanent and the mutation writes the cache directly, so never refetch.
		staleTime: Infinity,
	});

/** Permanently dismiss the given popup for the current user. */
export const useDismissPopup = (popupKey: PopupKey) => {
	const queryClient = useQueryClient();
	return useMutation({
		mutationFn: () => dismissPopup(popupKey),
		onSuccess: () => queryClient.setQueryData(popupQueryKey(popupKey), { dismissed: true }),
	});
};
